<template>
    <div class="wrap">

        <br>
        <br>
        <br>
        <div class="row">
            <div class="col text-center">
                <i class="bi bi-emoji-dizzy luna-color" style="font-size: 200px;"></i>
            </div>
        </div>
        <br>
        <br>
        <div class="row">
            <div class="col text-center luna-color">
                エラーが発生しました。再度ログインをお願いします。
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col text-center">
                <a href="/auth">ログインページへ</a>
            </div>
        </div>
    </div>
</template>
    
<script>
import { clearPageStorage } from '../event-log/clearPageStorage';

export default {
    data() {
        return {
        };
    },
    mounted() {
        clearPageStorage()
    },
}
</script>
